/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_3_TagInputs */

const en_mk_how_3_tag = /** @type {(inputs: Mk_How_3_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STEP 3`)
};

const id_mk_how_3_tag = /** @type {(inputs: Mk_How_3_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LANGKAH 3`)
};

/**
* | output |
* | --- |
* | "STEP 3" |
*
* @param {Mk_How_3_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_3_tag = /** @type {((inputs?: Mk_How_3_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_3_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_3_tag(inputs)
	return en_mk_how_3_tag(inputs)
});